import { komponentModule } from "./komponent/module";
import { recepturaModule } from "./receptura/module";
import { produktModule } from "./produkt/module";
import { asortymentModule } from "./asortyment/module";
import { wyrobModule } from "./wyrob/module";
import { productListModule } from "./productList/module";
import { brandModule } from "./brand/module";
import { jednostkaSprzedazyModule } from "./jednostkaSprzedazy/module";
import { productGroupModule } from "./productGroup/module";
import { languageModule } from "./language/module";
import { productionRecipeModule } from "./productionRecipe/module";

export const plmResourceModules = {
  komponent: komponentModule,
  receptura: recepturaModule,
  produkt: produktModule,
  wyrob: wyrobModule,
  asortyment: asortymentModule,
  productList: productListModule,
  brand: brandModule,
  jednostkaSprzedazy: jednostkaSprzedazyModule,
  productGroup: productGroupModule,
  language: languageModule,
  productionRecipe: productionRecipeModule,
};
